import { render } from "./ImportUnmanagedInstance.vue?vue&type=template&id=04fdef8a"
import script from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"
export * from "./ImportUnmanagedInstance.vue?vue&type=script&lang=js"

import "./ImportUnmanagedInstance.vue?vue&type=style&index=0&id=04fdef8a&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__